import { NavbarLink } from "./types";

export const defaultLinks: NavbarLink[] = [
  {
    id: "marketplace",
    name: "Marketplace",
    href: "/marketplace?viewType=grid&categories=all&sorting=1",
  },
];
